import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    processing: Boolean
  }

  connect() {
    // After a failed all-questions submission, bring the first invalid question into view.
    const firstErroredQuestion = this.element.querySelector('[data-question-error="true"]')
    if (firstErroredQuestion) {
      firstErroredQuestion.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }

  showSavingModalOnSubmit(event) {
    if (!this.processingValue) return

    const form = event.target
    if (!this.hasProcessableTextContent(form)) return

    const modalElement = document.getElementById("savingModal")
    if (!modalElement) return

    const modal = bootstrap.Modal.getOrCreateInstance(modalElement)
    modal.show()
  }

  hasProcessableTextContent(form) {
    const processingFields = form.querySelectorAll('[data-forms-responder-processes-text="true"]')
    if (processingFields.length > 0) {
      return Array.from(processingFields).some((field) => field.value.trim().length > 0)
    }

    const textField = form.querySelector('textarea[name*="[text]"], input[name*="[text]"]')
    return textField && textField.value.trim().length > 0
  }
}
